import { render, staticRenderFns } from "./attachmentModal.vue?vue&type=template&id=09f06917&"
import script from "./attachmentModal.vue?vue&type=script&lang=js&"
export * from "./attachmentModal.vue?vue&type=script&lang=js&"
import style0 from "./attachmentModal.vue?vue&type=style&index=0&id=09f06917&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports